import { Fragment } from 'react';
import { generatePath, NavLink } from 'react-router-dom';

import { PATHS } from '../../../../shared/constants';
import { useFolderTree } from '../context';
import { Folder } from '../models';

type FolderBreadcrumbsProps = {
  selectedFolder: Folder;
};

export const FolderBreadcrumbs: React.FC<FolderBreadcrumbsProps> = ({
  selectedFolder,
}) => {
  const { selectedFolderPath } = useFolderTree();

  return (
    <div className="text-sm text-gray-400">
      {selectedFolderPath.map(({ name, id }) => (
        <Fragment key={id}>
          <NavLink
            to={generatePath(PATHS.Documents, { folderId: id })}
            className="text-teal-500 underline"
          >
            {name}
          </NavLink>
          <span className="text-teal-500">{' > '}</span>
        </Fragment>
      ))}

      {selectedFolder.name}
    </div>
  );
};
